export default __webpack_public_path__ + "static/char-49-anr-e766e2ab80c91b7e034836fa52560735.gif";